// extracted by mini-css-extract-plugin
export var text = "_80-0";